import type { DropdownProps } from "@/components/mosaic/ui/TileTitle/TileTitle";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@/components/ui/select";

type EnumType = { [key: string]: string };
type ValueOf<T> = T[keyof T];

type ChartDropdownProps<T extends EnumType> = {
	enumType: T;
	value: ValueOf<T>;
	stateKey: string;
};

export const ChartDropdown = <T extends EnumType>({
	value,
	stateKey,
	enumType,
	onStateChange,
}: ChartDropdownProps<T> & Pick<DropdownProps, "onStateChange">) => {
	return (
		<Select
			value={value}
			onValueChange={(v: string) => onStateChange({ [stateKey]: v })}
		>
			<SelectTrigger className="min-w-[60px] news-select-trigger text-gold font-bold text-sm p-1 h-full border-none">
				<SelectValue data-testid="selectedValue">{value}</SelectValue>
			</SelectTrigger>

			<SelectContent>
				{Object.values(enumType).map((option) => (
					<SelectItem key={option} value={option}>
						{option}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);
};
